import Handlebars from 'handlebars/dist/handlebars';

(function ($) {
  'use strict';

  // [REFACTOR NOTE] Reason: Redundancy
  var arraySlice = Array.prototype.slice;
  window.arraySlice = arraySlice;

  function handlebarsIfCond(left, operator, right, options) {
    /*jshint validthis: true */
    var self = this;

    function returnResult(val) {
      return val ? options.fn(self) : options.inverse(self);
    }

    switch (operator) {
      case '==':
        return returnResult(left === right);
      case '!=':
        return returnResult(left !== right);
      case '===':
        return returnResult(left === right);
      case '!==':
        return returnResult(left !== right);
      case '<':
        return returnResult(left < right);
      case '<=':
        return returnResult(left <= right);
      case '>':
        return returnResult(left > right);
      case '>=':
        return returnResult(left >= right);
      case 'and':
        return returnResult(left && right);
      case 'or':
        return returnResult(left || right);
      case 'in':
        return returnResult(
          left ? right.split(/[,][\s?]+/).indexOf(left) >= 0 : false
        );
      default:
        return returnResult(false);
    }
  }
  window.handlebarsIfCond = handlebarsIfCond;

  var helpers = {
    /**
     * Block helper for checking whether a value exists in an array.
     * @param {*} value The value to search for.
     * @param {Array} array The array to search in.
     */
    contains: function (value, array, options) {
      if ($.inArray(value, array) !== -1) {
        return options.fn(this);
      } else {
        return options.inverse(this);
      }
    },
    eachkeys: function (context, options) {
      var ret = '';

      if (!context) return options.inverse(this);

      for (var key in context) {
        ret += options.fn({ key: key, value: context[key] });
      }

      return ret;
    },
    /**
     * Similar to the built-in `each` helper, but limit iteration to the first
     * `limit` items. If there are more items than `limit`, then the `else`
     * branch is executed *in addition*. This is unlike the built-in each,
     * where it is executed only if the list is empty.
     *
     * The `else` branch is passed a private variable `excess`, which
     * represents how many excess items there are.
     *
     * @param {array} context A list of items.
     * @param {number} limit The number of items to limit the iteration to.
     */
    eachlimit: function (context, limit, options) {
      var items = context.length;
      var excess = items - limit;
      var data, dataExcess;
      var ret = '';

      if (options.data) data = Handlebars.createFrame(options.data);
      if (excess > 0) {
        if (options.data) {
          dataExcess = Handlebars.createFrame(options.data);
          dataExcess.excess = excess;
        }
      } else {
        limit = items;
      }

      for (var i = 0; i < limit; i++) {
        if (data) data.index = i;
        ret += options.fn(context[i], { data: data });
      }

      if (dataExcess) ret += options.inverse(this, { data: dataExcess });
      return ret;
    },
    foreach: function (arr, options) {
      if (options.inverse && !arr.length) {
        return options.inverse(this);
      }

      return arr
        .map(function (item, index) {
          if (typeof item === 'string') {
            item = String(item);
          }

          item.$index = index;
          item.$first = index === 0;
          item.$last = index === arr.length - 1;

          return options.fn(item);
        })
        .join('');
    },
    forloop: function (from, to, incr, block) {
      var accum = '';
      for (var i = from; i < to; i += incr) {
        accum += block.fn(i);
      }
      return accum;
    },
    ifcond: function (left, operator, right, options) {
      return handlebarsIfCond.call(this, left, operator, right, options);
    },
    ifequal: function (left, right, options) { // Strict equality. e.g. '1' === 1 // => false.
      return left === right ? options.fn(this) : options.inverse(this);
    },
    ifindexof: function (value, left, operator, right, options) {
      var allowedOperators = ['<', '==', '!=', '>'];

      if (!value || isNaN(right) || allowedOperators.indexOf(operator) < 0)
        return options.inverse(this);

      return handlebarsIfCond.call(
        this,
        value.indexOf(left),
        operator,
        parseInt(right, 10),
        options
      );
    },
    ifitem: function (context, key, value, options) {
      var yes = String(context[key]) === String(value);
      return yes ? options.fn(this) : options.inverse(this);
    },
    iflike: function (left, right, options) {
      // Standard equality. e.g. '1' == 1 // => true.
      return left == right ? options.fn(this) : options.inverse(this);
    },
    ifmod: function (left, right, options) {
      return left % right ? options.fn(this) : options.inverse(this);
    },
    /**
     * Checks that the current grid phase is not equal to the value passed in.
     * @param {number} phase The current phase.
     * @param {number} index The phase iteration number to check against.
     */
    ifnotphase: function (phase, index, options) {
      // phase is `undefined` when the grid doesn't use displaymax, so provide
      // a default.
      phase = phase || 0;
      if (phase !== index)
        return options.fn(this);
      else
        return options.inverse(this);
    },
    /**
     * Block helper to choose the correct template branch based on the
     * browser's width.
     * @param {number} [width] Maximum width that will be considered skinny.
     *     Defaults to Gryphon's standard skinny max-width.
     * @param {object} options The options object provided by Handlebars.
     */
    ifskinny: function (width, options) {
      if (options === undefined) {
        options = width;
        width = Gryphon.widgets.MEDIA_SKINNY_MAX_WIDTH;
      }
      return $(window).width() <= width
        ? options.fn(this)
        : options.inverse(this);
    },
    /**
     * Like the 'if' block helper, but accepts any number of arguments. If any
     * are truthy, return the main block, otherwise return the else block.
     */
    or: function () {
      var len = arguments.length - 1;
      var args = Array.prototype.slice.call(arguments, 0, len);
      var options = arguments[len];

      for (var i = 0; i < len; i++) {
        if (args[i]) return options.fn(this);
      }

      return options.inverse(this);
    },
    unlesscond: function (left, operator, right, options) {
      return handlebarsIfCond.call(this, right, operator, left, options);
    },
    unlessequal: function (left, right, options) {
      return left === right ? options.inverse(this) : options.fn(this);
    },
  };
  window.helpers = { ...window.helpers, ...helpers };

  // Attach all the helper functions to the Handlebars namespace.
  for (var name in helpers) {
    if (Object.prototype.hasOwnProperty.call(helpers, name))
      Handlebars.registerHelper(name, helpers[name]);
  }
})(jQuery);
